module.exports = __webpack_public_path__ + "ca52047e62af407834cf64290752b1bb.png";